<template>
    <div>
        <b-modal id="addRule" ref="addRule" size="lg" @show="setData" @hide="closeModal" hide-header hide-footer
            no-close-on-backdrop no-close-on-esc centered>
            <div class="container-add-rule">
                <div class="d-flex justify-content-end">
                    <feather @click="$refs.addRule.hide()" style="width: 15px; cursor: pointer" type="x"></feather>
                </div>
                <div class="px-2 py-0">
                    <p style="font-size: 1.7em; font-weight: 500">
                        {{ editRuleData != null ? 'Edit Rule' : 'Create New Rule' }}
                    </p>
                </div>
                <div class="d-flex align-items-center px-2 py-1">
                    <div style="width: 20%">
                        <p class="mr-1 mb-0" style="font-weight: 400">Rule Name:</p>
                    </div>
                    <div style="width: 100%">
                        <!-- :class="{ 'border-red': isRequired && ruleName == '' }" -->
                        <b-form-input class="selectCondition mb-1" style="border: 1px solid #cdcdcd" type="text"
                            v-model="ruleName" @input='checkRequired' />
                        <!-- <span v-if="isRequired && ruleName == ''" style="color: #f73164; font-size: 0.6rem"
                            class="mt-2">
                            required
                        </span> -->
                    </div>
                </div>

                <div class="d-flex align-items-center px-2 py-0 mt-2">
                    <div style="width: 20%">
                        <p class="mr-1 mb-0" style="font-weight: 400">Rule Details:</p>
                    </div>
                    <div class="d-flex flex-column justify-content-center" style="width: 100%">
                        <!-- :class="{ 'border-red': isRequired && ruleDetails == '' }" -->
                        <b-form-input class="selectCondition mb-1" style="border: 1px solid #cdcdcd" type="text"
                            v-model="ruleDetails" />
                        <!-- <span 
                        v-if="isRequired && ruleDetails == ''" style="color: #f73164; font-size: 0.6rem"
                            class="mt-2">
                            required
                        </span> -->
                    </div>
                </div>

                <div class="px-2 py-1">
                    <!-- <p class="m-0">Routing Condition</p> -->
                    <p class="m-0">Condition</p>

                    <div class="d-flex align-items-center mt-2" v-for="(item, index) in condition" :key="index">
                        <div style="width: 15%; margin-right: 1em">
                            <v-select v-if="index != 0" class="selectCondition" id="optionGate" placeholder="Select"
                                :options="item.gateOption" v-model="item.selectedGate" style="width: 100%" />
                        </div>
                        <v-select id="optionOne" @input="selectSubject(item)" class="selectCondition"
                            placeholder="Select" :options="item.conOneOption" v-model="item.selectedConOne"
                            style="width: 25%" />
                        <v-select @input='checkRequired' id="optionTwo" placeholder="Operator"
                            :options="item.conTwoOption" v-model="item.selectedConTwo" class="selectCondition"
                            style="width: 25%" />
                        <b-form-input @input='checkRequired' id="valueInput" placeholder="Value" class="inputNum" style="
                width: 25%;
                height: 100%;
                border: 1px solid #cdcdcd;
                box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
                border-radius: 4px;
                margin-right: 10px;
                padding: 11px;
                font-size: 13px;
              " :type="item.selectedConOne == 'Attach Number Includes'
            ? 'number'
            : 'text'
            " v-model="item.value" />
                        <div v-if="condition.length > 1" @click="deleteCondition(index)"
                            class="rounded-circle d-flex align-items-center justify-content-center mt-2" style="
                background: #fbe9ef;
                color: #e94362;
                height: 2rem;
                width: 2rem;
                cursor: pointer;
              ">
                            <font-awesome-icon icon="fa-solid fa-trash" class="" style="font-size: 1.4em" />
                        </div>
                    </div>
                </div>

                <div class="mt-3 d-flex justify-content-start">
                    <b-button @click="addNewCondition" class="border-0 p-0 mr-0" id="addCon_btn"
                        style="background-color: #d5e3fd">
                        <div class="d-flex justify-content-center align-items-center add-btn w-100 h-100 px-3 py-1"
                            style="
                border-radius: 1.3em;
                background: #d5e3fd;
                color: #1271fb;
                height: 80%;
              ">
                            <feather class="mr-1" style="width: 0.8em; cursor: pointer" type="plus"></feather>
                            <span style="font-size: 13px"> Add Condition</span>
                        </div>
                    </b-button>
                </div>

                <div class="d-flex mt-3" style="width: 100%">
                    <div style="width: 15%; margin-right: 1em">
                        <p class="mr-1 mb-0" style="font-weight: 400">Route to:</p>
                    </div>

                    <div class="d-flex flex-column" style="width: 25%">
                        <div style="width: 100%">
                            <!-- :class="{ 'border-red': isRequired && selectedRoute == '' }"  -->
                            <v-select @input='checkRequired' id="queue" class="selectCondition" placeholder="Select"
                                :options="queue" v-model="selectedRoute" style="width: 100%" />
                        </div>
                        <!-- <p style="color: #f73164; font-size: 0.6rem" class="mt-2">
                            required
                        </p> -->
                    </div>
                </div>

                <div class="mt-3 d-flex justify-content-end">
                    <b-button @click="saveRule" :disabled='isRequired' class="border-0 p-0 mr-0" id="addCon_btn"
                        style="background-color: #036efb">
                        <div class="d-flex justify-content-center align-items-center add-btn w-100 h-100 px-4 py-1"
                            style="
                border-radius: 1.3em;
                background: #036efb;
                color: white;
                height: 80%;
              ">
                            <span style="font-size: 0.9em">{{
            editRuleData != null ? 'Save' : 'Add Rule'
                                }}</span>
                        </div>
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
// import { requestService } from '../../_services/request.service';

export default {
    props: ['editRuleData', 'data'],
    data() {
        return {
            isRequired: true,
            ruleName: '',
            ruleDetails: '',
            queue: [],
            queueOri: [],
            selectedRoute: '',
            condition: [
                {
                    gateOption: ['AND', 'OR'],
                    selectedGate: '',
                    conOneOption: [
                        'From Domain',
                        'Subject Includes',
                        'Attach Number Includes',
                    ],
                    selectedConOne: '',
                    conTwoOption: [],
                    // conTwoOption: [
                    //     'Contain',
                    //     'Does not contain',
                    //     'Equal to',
                    //     'Not equals',
                    //     'Greater than',
                    //     'Less than',
                    //     'Greater than or equal to',
                    //     'Less than or equal to',
                    //     'Starts with',
                    //     'Does not starts with',
                    //     'Ends with',
                    //     'Does not ends with',
                    // ],
                    selectedConTwo: '',
                    value: null,
                },
            ],
        };
    },
    mounted() { },
    methods: {
        checkRequired() {
            let check = this.checkBlankCondition(this.condition)
            // console.log('ruleName', this.ruleName)
            // console.log('this.ruleDetails', this.ruleDetails)
            // console.log('selectedRoute', this.selectedRoute)
            // console.log('check', check, this.condition)
            if (this.ruleName != '' &&
                this.ruleDetails != '' &&
                this.selectedRoute != '' && check) {
                this.isRequired = false
            } else {
                this.isRequired = true

            }
        },
        selectSubject(item) {
            if (item.selectedConOne == 'Attach Number Includes') {
                item.conTwoOption = [
                    'Equal to',
                    'Not equals',
                    'Greater than',
                    'Less than',
                    'Greater than or equal to',
                    'Less than or equal to',
                ];
                item.selectedConTwo = ''
                item.value = null
            } else {
                item.conTwoOption = [
                    'Contain',
                    'Does not contain',
                    'Equal to',
                    'Not equals',
                    'Starts with',
                    'Does not starts with',
                    'Ends with',
                    'Does not ends with',
                ];
                item.selectedConTwo = ''
                item.value = ''
            }
            this.checkRequired()
        },
        setData() {
            this.queue = this.data.queue;
            this.queueOri = this.data.queueOri;
            // console.log('editRuleData: ', this.editRuleData)
            if (this.editRuleData != null) {
                this.isRequired = false
                // console.log('editRuleData: ', this.editRuleData)
                this.condition = [];
                this.ruleName = this.editRuleData.rule_name;
                this.ruleDetails = this.editRuleData.rule_detail;
                let route = this.queueOri.find(
                    (item) => item._id === this.editRuleData.route_to
                );
                let routeName = route ? route.name : null;
                this.selectedRoute = routeName;
                this.editRuleData.condition.all.forEach((e) => {
                    let selectedOne = '';
                    let selectedTwo = '';
                    let conTwoArray = []

                    switch (e.var) {
                        case 'domain':
                            selectedOne = 'From Domain';
                            conTwoArray = [
                                'Contain',
                                'Does not contain',
                                'Equal to',
                                'Not equals',
                                'Starts with',
                                'Does not starts with',
                                'Ends with',
                                'Does not ends with',
                            ]
                            break;
                        case 'subject':
                            selectedOne = 'Subject Includes';
                            conTwoArray = [
                                'Contain',
                                'Does not contain',
                                'Equal to',
                                'Not equals',
                                'Starts with',
                                'Does not starts with',
                                'Ends with',
                                'Does not ends with',
                            ]
                            break;
                        case 'attached_length':
                            selectedOne = 'Attach Number Includes';
                            conTwoArray = [
                                'Equal to',
                                'Not equals',
                                'Greater than',
                                'Less than',
                                'Greater than or equal to',
                                'Less than or equal to',
                            ]
                            break;

                        default:
                            break;
                    }
                    switch (e.op) {
                        case 'contain':
                            selectedTwo = 'Contain';
                            break;
                        case 'does_not_contain':
                            selectedTwo = 'Does not contain';
                            break;
                        case 'equal_to':
                            selectedTwo = 'Equal';
                            break;
                        case 'not_equal':
                            selectedTwo = 'Not equals';
                            break;
                        case 'starts_with':
                            selectedTwo = 'Starts with';
                            break;
                        case 'does_not_starts_with':
                            selectedTwo = 'Does not starts with';
                            break;
                        case 'ends_with':
                            selectedTwo = 'Ends with';
                            break;
                        case 'does_not_ends_with':
                            selectedTwo = 'Does not ends with';
                            break;
                        case 'equal_to':
                            selectedTwo = 'Equal to';
                            break;
                        case 'not_equal':
                            selectedTwo = 'Not equals';
                            break;
                        case 'greater_than':
                            selectedTwo = 'Greater than';
                            break;
                        case 'less_than':
                            selectedTwo = 'Less than';
                            break;
                        case 'greater_than_or_equal_to':
                            selectedTwo = 'Greater than or equal to';
                            break;
                        case 'less_than_or_equal_to':
                            selectedTwo = 'Less than or equal to';
                            break;
                    }
                    // console.log('selectedTwo: ', e.op, selectedTwo);

                    let obj = {
                        gateOption: ['AND', 'OR'],
                        selectedGate: 'AND',
                        conOneOption: [
                            'From Domain',
                            'Subject Includes',
                            'Attach Number Includes',
                        ],
                        conTwoOption: conTwoArray,
                        selectedConOne: selectedOne,
                        selectedConTwo: selectedTwo,
                        value: e.value,
                    };
                    this.condition.push(obj);
                });

                this.editRuleData.condition.any.forEach((e) => {
                    let selectedOneAny = '';
                    let selectedTwoAny = '';

                    switch (e.var) {
                        case 'domain':
                            selectedOneAny = 'From Domain';
                            break;
                        case 'subject':
                            selectedOneAny = 'Subject Includes';
                            break;
                        case 'attached_length':
                            selectedOneAny = 'Attach Number Includes';
                            break;

                        default:
                            break;
                    }
                    switch (e.op) {
                        case 'contain':
                            selectedTwoAny = 'Contain';
                            break;
                        case 'does_not_contain':
                            selectedTwoAny = 'Does not contain';
                            break;
                        case 'equal_to':
                            selectedTwoAny = 'Equal';
                            break;
                        case 'not_equal':
                            selectedTwoAny = 'Not equals';
                            break;
                        case 'starts_with':
                            selectedTwoAny = 'Starts with';
                            break;
                        case 'does_not_starts_with':
                            selectedTwoAny = 'Does not starts with';
                            break;
                        case 'ends_with':
                            selectedTwoAny = 'Ends with';
                            break;
                        case 'does_not_ends_with':
                            selectedTwoAny = 'Does not ends with';
                            break;
                        case 'equal_to':
                            selectedTwoAny = 'Equal to';
                            break;
                        case 'not_equal':
                            selectedTwoAny = 'Not equals';
                            break;
                        case 'greater_than':
                            selectedTwoAny = 'Greater than';
                            break;
                        case 'less_than':
                            selectedTwoAny = 'Less than';
                            break;
                        case 'greater_than_or_equal_to':
                            selectedTwoAny = 'Greater than or equal to';
                            break;
                        case 'less_than_or_equal_to':
                            selectedTwoAny = 'Less than or equal to';
                            break;
                    }
                    let obj = {
                        gateOption: ['AND', 'OR'],
                        selectedGate: 'OR',
                        conOneOption: [
                            'From Domain',
                            'Subject Includes',
                            'Attach Number Includes',
                        ],
                        conTwoOption: [
                            'Equal to',
                            'Not equals',
                            'Greater than',
                            'Less than',
                            'Greater than or equal to',
                            'Less than or equal to',
                        ],
                        selectedConOne: selectedOneAny,
                        selectedConTwo: selectedTwoAny,
                        value: e.value,
                    };
                    this.condition.push(obj);
                });

                // console.log('editRuleData: ', this.editRuleData);
            }
        },
        checkBlankCondition(item) {
            for (let i = 0; i < item.length; i++) {
                const condition = item[i];

                // Check if selectedConOne, selectedConTwo are blank or value is null
                if (condition.selectedConOne === '' || condition.selectedConTwo === '' || condition.value === null || condition.value === '') {
                    return false; // If any condition is not met, return false
                }
            }

            return true; // If all conditions are met for all items, return true
        },
        saveRule() {
            // console.log('condition: ', this.condition)
            // console.log('editRuleData: ', this.editRuleData)
            let all = [];
            let any = [];
            this.condition.forEach((e, index) => {
                let vaSelected = '';
                switch (e.selectedConOne) {
                    case 'From Domain':
                        vaSelected = 'domain';
                        break;
                    case 'Subject Includes':
                        vaSelected = 'subject';
                        break;
                    case 'Attach Number Includes':
                        vaSelected = 'attached_length';
                        break;
                }

                let opSelected = null;
                let valueSelected = '';
                if (e.selectedConOne != 'Attach Number Includes') {
                    valueSelected = e.value;
                    // console.log('selectedConTwo:', e.selectedConTwo)
                    switch (e.selectedConTwo) {
                        case 'Contain':
                            opSelected = 'contain';
                            break;
                        case 'Does not contain':
                            opSelected = 'does_not_contain';
                            break;
                        case 'Equal to':
                            opSelected = 'equal_to';
                            break;
                        case 'Not equals':
                            opSelected = 'not_equal';
                            break;
                        case 'Starts with':
                            opSelected = 'starts_with';
                            break;
                        case 'Does not starts with':
                            opSelected = 'does_not_starts_with';
                            break;
                        case 'Ends with':
                            opSelected = 'ends_with';
                            break;
                        case 'Does not ends with':
                            opSelected = 'does_not_ends_with';
                            break;

                        default:
                            opSelected = '';
                            break;
                    }
                } else {
                    if (e.value == null) {
                        valueSelected = 0;
                    } else {
                        valueSelected = Number(e.value);
                    }
                    switch (e.selectedConTwo) {
                        case 'Equal to':
                            opSelected = 'equal_to';
                            break;
                        case 'Not equals':
                            opSelected = 'not_equal';
                            break;
                        case 'Greater than':
                            opSelected = 'greater_than';
                            break;
                        case 'Less than':
                            opSelected = 'less_than';
                            break;
                        case 'Greater than or equal to':
                            opSelected = 'greater_than_or_equal_to';
                            break;
                        case 'Less than or equal to':
                            opSelected = 'less_than_or_equal_to';
                            break;
                        default:
                            opSelected = '';
                            break;
                    }
                }

                let obj = {
                    var: vaSelected,
                    op: opSelected,
                    value: vaSelected == 'attached_length' ? Number(e.value) : e.value,
                };
                if (index == 0 || e.selectedGate == 'AND') {
                    all.push(obj);
                } else {
                    any.push(obj);
                }
            });

            let route = this.queueOri.find(
                (item) => item.name === this.selectedRoute
            );
            let routeId = route ? route._id : null;
            let selectCon = {
                all: all,
                any: any,
            };

            let payload = {
                rule_name: this.ruleName,
                rule_detail: this.ruleDetails,
                route_to: `${routeId}`,
                condition: selectCon,
                // index: this.editRuleData != null ? this.editRuleData.originalIndex : null
            };


            this.isRequired = false;
            // console.log('payload: ', payload)
            if (this.editRuleData == null) {
                this.$emit('addNewRule', payload);
            } else {
                payload._id = this.editRuleData._id;
                payload.index = this.editRuleData.index;
                payload.status = this.editRuleData.status
                this.$emit('editRule', payload);
            }
            this.$refs['addRule'].hide();
        },
        deleteCondition(index) {
            if (this.condition.length != 1) {
                this.condition.splice(index, 1);
            }
        },
        addNewCondition() {
            this.condition.push({
                gateOption: ['AND', 'OR'],
                selectedGate: '',
                conOneOption: [
                    'From Domain',
                    'Subject Includes',
                    'Attach Number Includes',
                ],
                selectedConOne: '',
                conTwoOption: [
                ],
                selectedConTwo: '',
                value: null,
            });
        },
        closeModal() {
            // this.editRuleData = null;
            this.$emit('clearEdit')
            this.ruleName = '';
            this.ruleDetails = '';
            this.selectedRoute = '';
            this.condition = [
                {
                    gateOption: ['AND', 'OR'],
                    selectedGate: '',
                    conOneOption: [
                        'From Domain',
                        'Subject Includes',
                        'Attach Number Includes',
                    ],
                    selectedConOne: '',
                    conTwoOption: [
                        // 'Contain',
                        // 'Does not contain',
                        // 'Equal to',
                        // 'Not equals',
                        // 'Greater than',
                        // 'Less than',
                        // 'Greater than or equal to',
                        // 'Less than or equal to',
                        // 'Starts with',
                        // 'Does not starts with',
                        // 'Ends with',
                        // 'Does not ends with',
                    ],
                    selectedConTwo: '',
                    value: null,
                },
            ];
        },
    },
};
</script>

<style scoped>
.border-red {
    border: 1.5px solid red !important;
}
</style>
<style>
#valueInput>>>input#valueInput {
    font-size: 13px !important;
}
</style>
<style scoped>
.inputNum::-webkit-inner-spin-button,
inputNum::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

div#optionOne {
    font-size: 13px;
}

div#optionTwo {
    font-size: 13px;
}

div#queue {
    font-size: 13px;
}

div#optionGate {
    font-size: 13px;
    height: 38px;
}

.selectCondition {
    border: none;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    margin-right: 1em;
    /* border: 1px solid #cdcdcd; */
    width: 100%;
    height: 100%;
}

#optionGate>>>input.vs__search {
    font-size: 13px;
    padding: 5px;
}

#optionOne>>>input.vs__search {
    font-size: 13px;
    padding: 5px;
}

#optionTwo>>>input.vs__search {
    font-size: 13px;
    padding: 5px;
}

#queue>>>input.vs__search {
    font-size: 13px;
    padding: 5px;
}

button#addCon_btn {
    background-color: transparent !important;
}

.btn-secondary {
    background-color: none;
}

.container-add-rule {
    font-size: 10px;
    padding: 0.5em;
}

.container-add-rule p {
    font-size: 1.4em;
}
</style>
